import React from 'react';
import './Aboutus.css'; 
import NavBar from "../components/NavBar";
import RtsTeam from "../assets/rtsteam.png";
import SEO from "../components/SEO";

const sections = {
  coreValues: [
    { title: "Innovation", description: "We embrace cutting-edge technologies and creative problem-solving approaches to deliver exceptional solutions that keep you ahead of industry trends and competitive challenges." },
    { title: "Customer Focus", description: "By engaging professionals of practice, we prioritize understanding your unique business needs and consistently strive to exceed expectations through personalized service and measurable results." },
    { title: "Collaboration", description: "We work seamlessly with your leadership & teams to achieve common goals, fostering a supportive environment that encourages knowledge sharing and continuous improvement." },
    { title: "Integrity", description: "We operate with unwavering honesty and transparency, building lasting trust with our clients and partners through ethical business practices and reliable delivery." },
  ],
  services: [
    { title: "Advisory Services", description: "Transformation consulting and process optimization" },
    { title: "Learning & Development", description: "Technology, behavioral, and leadership training programs" },
    { title: "Talent Acquisition", description: "Strategic recruitment solutions for technology and leadership roles" },
    { title: "Cloud Labs", description: "Hands-on learning environments for emerging technologies" },
  ]
};
const statsData = [
  
    {
        id: 3,
        title: "450+",
        subtitle: "Talent Development",
        description: "Through 450+ specialised interventions in behavioural and leadership development, we have supported the professional growth of 10,000+ associates and leaders, fostering stronger teams and future-ready Organisations."
    },
      {
        id: 1,
        title: "300+",
        subtitle: "Talent Acquisition",
        description: " Having executed 150+ mandates and facilitated over 3,000 successful hires, we bring deep expertise in tech and non-tech recruitment across the full talent spectrum."
    },
    {
        id: 2,
        title: "600 +",
        subtitle: "Cloud Labs",
        description: "Our remote labs offer flexible, hands-on environments that enable technology teams to learn and practice across leading-edge domains—cloud technologies, modern programming stacks, data and analytics, AI/ML workflows, DevOps pipelines, cybersecurity, and digital automation toolsets."
    },
];

const RTSPage = () => {
  return (
    <div className="rts-page">
      <SEO
        title="About Us"
        description="Learn about RTS Techsol, our mission, core values, service approach, and experience in talent development, cloud labs, and advisory services."
        path="/about"
      />
      <NavBar />
      <div className="rts-section rts-intro-services-container">
        <div className="rts-intro">
          <h1 className="rts-title-primary">Introduction to RTS Techsol</h1>
          <h2 className="rts-title-secondary">Rise To Scale</h2>
          <p className="rts-paragraph"> Welcome to RTS Techsol — where innovation meets excellence in technology services. We like to be your strategic partner in navigating the complex landscape of modern business transformation needs. Our mission goes beyond solving current problems — we empower organizations to Rise to Scale by delivering comprehensive, future-ready training & technology solutions that drive growth, enhance efficiency, and create lasting competitive advantage. </p>
          <p className="rts-paragraph rts-mt-4"> With a focus on scalability, agility, and innovation, RTS Techsol enables businesses & teams to elevate their potential, accelerate transformation, and lead with confidence in an ever-evolving digital world. </p>
        </div>
        <div className="rts-services-grid">
          <div className="rts-services-left">
              <img src= {RtsTeam} alt="Business team looking at a sunrise" className="rts-team-image" />
                <h3 className="rts-subtitle">Our Commitment</h3>
                <p className="rts-paragraph rts-mb-6"> Delivering innovative solutions, exceptional training, and unwavering support to meet your business needs. We combine strategic thinking with practical execution to ensure measurable outcomes. </p>
                <p className="rts-paragraph rts-font-semibold"> Experience: Over 30 years of collective expertise in Talent Acquisition, Development, Coaching, and Advisory Services across Fortune 500 companies and emerging enterprises. </p>
            </div>
            <div className="rts-services-right">
                <h3 className="rts-subtitle">Key Service Offerings</h3>
                <div className="rts-service-blocks">
                    {sections.services.map((service, index) => (
                        <div key={index} className="rts-service-block">
                            <h4 className="rts-service-title">{service.title}</h4>
                            <p className="rts-service-description">{service.description}</p>
                        </div>
                    ))}
                </div>
                 <div className="rts-advisory-board">
                    <p className="rts-advisory-text"> Advisory Board: Seasoned leaders with deep expertise in Learning & Development, Talent Management, Technology-powered Talent Acquisition and Human Resources strategy. </p>
                </div>
            </div>
        </div>
      </div>
      <div className="rts-core-values-section">
        <div className="rts-section rts-core-values-container">
            <div className="rts-core-values-header">
             <h2 className="rts-core-values-title">Our Core Values</h2>
            </div>
            <div className="rts-core-values-grid">
                {sections.coreValues.map((value, index) => (
                    <div key={index} className="rts-core-value-card" >
                        <h3 className="rts-core-value-title">{value.title}</h3>
                        <p className="rts-paragraph">{value.description}</p>
                    </div>
                ))}
            </div>
             <div className="stats-section">
        {statsData.map((stat) => (
            <div key={stat.id} className="stat-card">
                <h1>{stat.title}</h1>
                <h2>{stat.subtitle}</h2>
                <p>{stat.description}</p>
            </div>
        ))}
      </div>
        </div>
      </div>
    </div>

    
    
  );
  
  
};

export default RTSPage;
